import { useContext } from 'react'

import { DateLocale } from '../context'

export function useDateLocale() {
  return useContext(DateLocale)
}
